import {PathUrlEnum} from '../../utils/analytics.utils';
import {AnalyticsService} from '../../shared/services/analytics/analytics.service';
import {Component, OnInit} from '@angular/core';

import {ISellerPayloadData} from 'src/app/shared/interfaces/ISeller';
import {Router} from "@angular/router";
import {RouteUtils} from "../../utils/route.utils";
import {PercentService} from "../../shared/services/percent/percent.service";

@Component({
  selector: 'app-seller-success',
  templateUrl: './seller-success.component.html',
  styleUrls: ['./seller-success.component.scss'],
})
export class SellerSuccessComponent implements OnInit {
  sellerPercentageData: ISellerPayloadData;
  isLoadingData = true;
  showError = false;
  errorCount: number = 0;

  constructor(
    private analyticsService: AnalyticsService,
    private percentService: PercentService,
    private router: Router,
  ) {
  }

  ngOnInit(): void {
    this.analyticsService.track(PathUrlEnum.PROPRIETARIO_FORMS_JA_PREENCHIDOS);
    this.personList();
  }

  personList() {
    this.isLoadingData = true;
    this.percentService.getSellersPercentages().subscribe({
      next: (response) => {
        this.sellerPercentageData = response;
        this.isLoadingData = false;
      },
      error: () => {
        this.isLoadingData = false;
        this.showError = true;
      }
    });
  }

  reciverTryAgain() {
    this.errorCount++;
    this.showError = false;
    this.personList();
  }

  redirectToFormList(): void {
    this.router.navigateByUrl(RouteUtils.PAGES.LOGIN);
  }

}
